import * as React from "react";
import { styled, alpha } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import EditIcon from "@mui/icons-material/Edit";
import Divider from "@mui/material/Divider";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import DeleteIcon from "@mui/icons-material/Delete";
import LayersClearIcon from "@mui/icons-material/LayersClear";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import Swal from "sweetalert2";
import api from "../../API/api";

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

export default function GeneralAction(props) {
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  function openModal() {
    props.handleClickOpen(props.data);
  }

  function handleCourse() {
    props.handleClickOpen(props.data);
    props.setModalData(props.data);
  }

  function handleCopyCourse() {
    // console.log("f", props);
    props.handleCopyCourse(props.data);
  }

  // console.log(props,'props2');

  function handleView() {
    navigate(`/admin/Publication`, { state: { facultyId: props.data.id } });
  }
  function handleStudentStatus() {
    props.handleStatusModal(props.data);
  }

  function handleViewOpen(data) {
    props.handleViewOpen(data);
  }
  function handleAchivement(e) {
    props.handleAchivement(e);
  }

  function handleDeleteAchive(data) {
    props.handleDelete(data);
  }

  function deleteStudents(data) {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        props.deleteStudent(data);
        //   Swal.fire({
        //     title: "Deleted!",
        //     text: "Your file has been deleted.",
        //     icon: "success"
        //   });
      }
    });
  }

  function deleteFaculty(data) {
    // console.log(data);

    props.deleteFaculty(data);
    return;

    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        api
          .deleteFaculty(data.id)
          .then((res) => {
            console.log("res", res);
            if (res.data.status === 200) {
              Swal.fire({
                title: "Deleted!",
                text: "Your data has been deleted.",
                icon: "success",
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });

        // props.deleteStudent(data)
        //   Swal.fire({
        //     title: "Deleted!",
        //     text: "Your file has been deleted.",
        //     icon: "success"
        //   });
      }
    });
  }

  const menuItems = () => {
    return (
      <>
        {props.type === "school" && (
          <>
            <MenuItem
              disableRipple
              onClick={() => props.handleClickOpen(props.data)}
            >
              <EditIcon />
              Edit
            </MenuItem>
            <MenuItem disableRipple>
              <DeleteIcon />
              Delete
            </MenuItem>
            <Divider sx={{ my: 0.5 }} />
            <MenuItem onClick={handleClose} disableRipple>
              <MoreHorizIcon />
              More
            </MenuItem>
          </>
        )}

        {/* blog  */}
        {!props.type && (
          <>
            {props.type && (
              <MenuItem onClick={openModal} disableRipple>
                <RemoveRedEyeIcon />
                View
              </MenuItem>
            )}
            <MenuItem onClick={openModal} disableRipple>
              <EditIcon />
              Edit
            </MenuItem>
            {props?.typed == "achive" && (
              <MenuItem
                onClick={() => handleDeleteAchive(props.data)}
                disableRipple
              >
                <DeleteIcon />
                Delete
              </MenuItem>
            )}
          </>
        )}
        {props.type === "course" && (
          <>
            <MenuItem disableRipple onClick={handleCourse}>
              <EditIcon />
              Edit
            </MenuItem>

            <MenuItem disableRipple>
              <DeleteIcon />
              Delete
            </MenuItem>

            <Divider sx={{ my: 0.5 }} />

            <MenuItem disableRipple onClick={handleCopyCourse}>
              <EditIcon />
              New Session
            </MenuItem>

            {/* <MenuItem onClick={handleClose} disableRipple>
                            <MoreHorizIcon />
                            More
                        </MenuItem> */}
          </>
        )}
        {props.type === "faculty" && (
          <>
            <MenuItem
              disableRipple
              onClick={() => props.handleClickOpen(props.data)}
            >
              <EditIcon />
              Edit
            </MenuItem>
            <MenuItem disableRipple onClick={() => deleteFaculty(props.data)}>
              <DeleteIcon />
              Delete
            </MenuItem>
            <MenuItem disableRipple onClick={handleView}>
              <RemoveRedEyeIcon />
              View Publication
            </MenuItem>
            <MenuItem
              disableRipple
              onClick={() => handleAchivement(props.data)}
            >
              <AddIcon />
              Add Achievement
            </MenuItem>
          </>
        )}
        {props.type === "student" && (
          <>
            <MenuItem
              disableRipple
              onClick={() => props.handleClickOpen(props.data)}
            >
              <EditIcon />
              Edit
            </MenuItem>

            {props.data?.isApprove === 1 ? (
              <MenuItem
                disableRipple
                onClick={() => handleViewOpen(props.data)}
              >
                <RemoveRedEyeIcon />
                View Details
              </MenuItem>
            ) : (
              <MenuItem
                disableRipple
                onClick={() => handleViewOpen(props.data)}
              >
                <RemoveRedEyeIcon />
                Approve
              </MenuItem>
            )}

            <MenuItem
              disableRipple
              onClick={() => handleAchivement(props.data)}
            >
              <AddIcon />
              Add Achievement
            </MenuItem>
            {props.data?.isApprove === 1 && (
              <MenuItem disableRipple onClick={handleStudentStatus}>
                <LayersClearIcon />
                Edit Status
              </MenuItem>
            )}
            <MenuItem disableRipple onClick={() => deleteStudents(props.data)}>
              <DeleteIcon />
              Delete Student
            </MenuItem>
          </>
        )}
        {props.type === "blog" && (
          <>
            <MenuItem
              onClick={() => props.handleClickOpenView(props.data)}
              disableRipple
            >
              <RemoveRedEyeIcon />
              View
            </MenuItem>
            <MenuItem onClick={openModal} disableRipple>
              <EditIcon />
              Edit
            </MenuItem>
          </>
        )}
      </>
    );
  };

  return (
    <div>
      <Button
        id="demo-customized-button"
        aria-controls={open ? "demo-customized-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        // variant="contained"
        disableElevation
        onClick={handleClick}
        endIcon={<EditIcon />}
      >
        {/* Options */}
      </Button>

      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          "aria-labelledby": "demo-customized-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {menuItems()}
      </StyledMenu>
    </div>
  );
}
